import { useNavigate } from "react-router-dom"
import DynamicDatatable from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import styles from "./Performance.module.scss"
import { MdBarChart } from "react-icons/md"

const Performance = () => {
  const navigate = useNavigate()

  const data = [
    { partnerName: "Abc Logistics", onTimeDeliveries: "98%", totalOrders: "300", returnRate: "99%", lastAudit: "30-11-2024" },
    { partnerName: "Global Warehouse", onTimeDeliveries: "95%", totalOrders: "400", returnRate: "97%", lastAudit: "20-11-2024" },
  ]

  const columns = [
    { name: "Partner Name", selector: (row) => row.partnerName },
    { name: "On-Time Deliveries", selector: (row) => row.onTimeDeliveries },
    { name: "Total Orders", selector: (row) => row.totalOrders },
    { name: "Retrun Rate", selector: (row) => row.returnRate },
    { name: "Last Audit", selector: (row) => row.lastAudit },
    {
      name: "View",
      cell: () => (
        <button className={styles["btn"]} onClick={() => navigate("/fbm-management/view-partner-performance-detail")}>
          <MdBarChart size={24} />
        </button>
      ),
    },
  ]

  return (
    <>
      <div className={styles["content"]}>
        <div className="fw-semibold fs-5 p-3">Partner Performance</div>
      </div>
      <DynamicDatatable data={data} columns={columns} type="yellow" />
    </>
  )
}

export default Performance
